<template>
    <vx-card id="loader">
        <h3 class="mb-3">Добавление топа EPC</h3>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        v-model="form.name"
                        :danger="!!errors.name"
                        :danger-text="errors.name"
                        autocomplete="off"
                        label="Название топа"
                        class="mt-1 w-full required"
                    />
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        label="Количество лидов для реального EPC"
                        placeholder="Введите количество лидов..."
                        v-model="form.leadsAmount"
                        :danger="!!errors.leadsAmount"
                        :danger-text="errors.leadsAmount"
                        class="w-full required"
                        type="number"
                        min="0"
                    />
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        label="Количество дней для расчета реального EPC"
                        placeholder="Введите количество лидов..."
                        v-model="form.periodEpc"
                        :danger="!!errors.periodEpc"
                        :danger-text="errors.periodEpc"
                        class="w-full required"
                        type="number"
                        min="0"
                    />
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        label="Количество дней для потенциального EPC"
                        placeholder="Введите количество дней..."
                        v-model="form.periodPotentialEpc"
                        :danger="!!errors.periodPotentialEpc"
                        :danger-text="errors.periodPotentialEpc"
                        class="w-full required"
                        type="number"
                        min="0"
                    />
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        label="Максимальный EPC для разгона тизеров"
                        placeholder="Введите максимальный EPC..."
                        v-model="form.maxEpc"
                        :danger="!!errors.maxEpc"
                        :danger-text="errors.maxEpc"
                        class="w-full required"
                        type="number"
                        min="0"
                    />
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        label="Типы трафика"
                        placeholder="Введите типы трафика (через запятую)"
                        v-model="form.contentTypes"
                        :danger="!!errors.contentTypes"
                        :danger-text="errors.contentTypes"
                        class="w-full"
                    />
                </div>
            </div>
        </div>

        <h5 class="mt-10 mb-2">Параметры таргетинга</h5>
        <div class="vx-row mb-2">
            <div class="vx-col w-1/2 mb-1">
                <div class="vx-row">
                    <div class="vx-col w-5/6 mb-1">
                        <label class="vs-input--label required"> Платформы </label>
                        <v-select
                            multiple
                            :options="dicts.deviceTypes"
                            @input="setSelected(form.deviceTypes, 'deviceTypes')"
                            label="name"
                            placeholder="Выберите платформы"
                            class="w-full"
                            v-bind:class="{ 'select-error': !!errors.deviceTypes }"
                            v-model="form.deviceTypes"
                        >
                        </v-select>
                        <div
                            v-if="errors.deviceTypes"
                            class="con-text-validation span-text-validation-danger vs-input--text-validation-span"
                            style="height: 19px"
                        >
                            <span class="span-text-validation">
                                {{ errors.deviceTypes }}
                            </span>
                        </div>
                    </div>
                    <vx-tooltip text="Очистить список" position="top" delay=".3s">
                        <feather-icon
                            icon="XIcon"
                            @click="form.deviceTypes = []"
                            class="inline-block text-danger cursor-pointer"
                            svgClasses="w-5 h-5"
                        />
                    </vx-tooltip>
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2 mb-1">
                <div class="vx-row">
                    <div class="vx-col w-5/6 mb-1">
                        <label class="vs-input--label required"> Страны </label>
                        <v-select
                            multiple
                            @input="setSelected(form.countries, 'countries')"
                            :options="dicts.countries"
                            label="name"
                            placeholder="Выберите страны"
                            class="w-full"
                            v-bind:class="{ 'select-error': !!errors.countries }"
                            v-model="form.countries"
                        >
                        </v-select>
                        <div
                            v-if="errors.countries"
                            class="con-text-validation span-text-validation-danger vs-input--text-validation-span"
                            style="height: 19px"
                        >
                            <span class="span-text-validation">
                                {{ errors.countries }}
                            </span>
                        </div>
                    </div>
                    <vx-tooltip text="Очистить список" position="top" delay=".3s">
                        <feather-icon
                            icon="XIcon"
                            @click="form.countries = []"
                            class="inline-block text-danger cursor-pointer"
                            svgClasses="w-5 h-5"
                        />
                    </vx-tooltip>
                </div>
            </div>
        </div>

        <vs-button class="mt-5 mr-2" color="success" @click="saveTop()" type="filled"> Сохранить </vs-button>

        <vs-button class="mt-5" color="primary" @click="cancelEdit()" type="filled"> Отмена </vs-button>
    </vx-card>
</template>

<script>
import vSelect from 'vue-select';
import axios from 'axios';

export default {
    name: 'epc-create',
    data() {
        return {
            top: undefined,
            dicts: {
                deviceTypes: [],
                countries: []
            },
            form: {
                name: '',
                leadsAmount: 100,
                periodEpc: 14,
                periodPotentialEpc: 10,
                maxEpc: '',
                deviceTypes: [],
                countries: [],
                contentTypes: ''
            },
            errors: {
                name: '',
                leadsAmount: '',
                periodEpc: '',
                periodPotentialEpc: '',
                maxEpc: '',
                deviceTypes: '',
                countries: '',
                contentTypes: ''
            }
        };
    },
    components: {
        'v-select': vSelect
    },
    methods: {
        loadData() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.axios.get('tops-epc/dicts').then((dicts) => {
                this.setDictionaries(dicts.data);
                this.$vs.loading.close('#loader > .con-vs-loading');
            });
        },
        setDictionaries(dicts) {
            const dictCountries = [{ id: -1, name: 'Все страны' }];
            dicts.countries
                .filter((c) => c.active)
                .forEach((c) => {
                    dictCountries.push(c);
                });
            this.dicts.countries = dictCountries;

            const dictDevices = [];
            dicts.deviceTypes
                .filter((d) => d.active)
                .forEach((b) => {
                    dictDevices.push(b);
                });
            this.dicts.deviceTypes = dictDevices;
        },
        setSelected(values, key) {
            var lastOption = values[values.length - 1];
            if (lastOption && lastOption.id == -1) {
                this.form[key] = [lastOption];
            } else {
                const alloption = values.find((c) => c.id === -1);
                if (alloption) {
                    this.form[key] = values.filter((c) => c.id !== -1);
                }
            }
        },
        saveTop() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            const countries = this.form.countries.map((c) => c.id);
            const deviceTypes = this.form.deviceTypes.map((d) => d.id);

            const params = {
                name: this.form.name,
                leadsAmount: this.form.leadsAmount,
                periodEpc: this.form.periodEpc,
                periodPotentialEpc: this.form.periodPotentialEpc,
                maxEpc: this.form.maxEpc,
                deviceTypes: deviceTypes,
                countries: countries,
                contentTypes: this.form.contentTypes
            };
            this.$axios({
                method: 'POST',
                url: 'tops-epc',
                params: params,
                errors: this.errors,
                success: (user) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Успешно добавлено',
                        text: 'Топ успешно добавлен',
                        color: 'success'
                    });
                    this.$router.push('/epc');
                },
                catch: (err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    return this.$vs.notify({
                        title: 'Внимание!',
                        text: 'Ошибка при добавлении топа!',
                        color: 'danger'
                    });
                }
            });
        },
        cancelEdit() {
            this.$router.push('/epc');
        }
    },
    mounted() {
        this.loadData();
    }
};
</script>

<style>
.select-error > div {
    border: 1px solid rgba(var(--vs-danger), 1) !important;
}
</style>
